/**
 * 设置页面标题
 * @param {String} title 标题
 */
export const setPageTitle = (title) => {
  if (title) {
    document.title = title;
  }
};

/**
 * px转化vw
 * @param {String | Number} pixel 像素
 */
export function pxToViewport(pixel) {
  const reg = /^(\d*)(px)?$/;
  if (reg.test(String(pixel))) {
    const viewport = 750;
    const px = Number(String(pixel).replace(reg, '$1'));
    const conversion = (px / viewport) * 100;
    return `${conversion.toFixed(3)}vw`;
  }
  return undefined;
}

/**
 * 获取cookie字段信息
 * @param {String} name cookie字段名称
 */
export function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return decodeURIComponent(arr[2]);
  }
  return undefined;
}

/**
 * echarts样式中转化比例
 * @param {Number} pixel 像素数值，pixel * 当前视口宽/设计稿宽
 */
export function calPxByScale(pixel) {
  const curWidth = document.documentElement.clientWidth;
  return Number.isFinite(pixel) ? pixel * (curWidth / 750) : pixel;
}

/*
 * 判断是否在微信环境中
 */
export function isWeChat() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  const ua = window.navigator.userAgent.toLowerCase();
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  return /micromessenger/.test(ua);
}

/**
 * 节流函数
 * @param {} fn
 * @param {*} wait
 * @returns
 */
export function throttle(fn, wait) {
  let inThrottle;
  let lastFn;
  let lastTime;
  // eslint-disable-next-line func-names
  return function () {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(() => {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
}

/**
 * 防抖函数
 * @param {} fn
 * @param {*} ms
 * @returns
 */
export const debounce = (fn, ms = 0) => {
  let timeoutId;
  // eslint-disable-next-line func-names
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
